import React, { FC } from 'react'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material'

export interface OrgSettingsBodyBaseProps {
	children?: React.ReactNode
	wrapperSx?: object
	containerSx?: object
}

const OrgSettingsBodyBase: FC<OrgSettingsBodyBaseProps> = ({
	children,
	wrapperSx,
	containerSx,
}: OrgSettingsBodyBaseProps) => {
	const theme = useTheme()

	return (
		<Box
			flexGrow={1}
			display={'flex'}
			flexDirection={'column'}
			sx={{
				width: '100%',
				marginTop: 7,
				position: 'relative',
				overflow: 'hidden',
				'.MuiPaper-root.MuiPaper-elevation': {
					borderRadius: '26px',
				},
				'.MuiTableContainer-root': {
					display: 'flex',
				},
				...wrapperSx,
			}}
		>
			<Paper
				sx={{
					flexGrow: 1,
					overflow: 'hidden',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
					boxShadow: 'none',
					border: `solid 1px ${theme?.palette.grey[300]}`,
					...containerSx,
				}}
			>
				{children}
			</Paper>
		</Box>
	)
}

export default OrgSettingsBodyBase
